/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState } from 'react';
import { practiceScore } from '@app/api/academic.api';
import { notificationController } from '@app/controllers/notificationController';
import { Spin } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '@app/store/store';

interface AnswerProps {
  showAnswer: boolean;
  audioURL: string;
  gradingContent: string;
  showNote: boolean;
  transcript?: boolean;
  audioQuestion?: string;
  questionId: string;
  audioBlod?: Blob;
}

export const Answer: React.FC<AnswerProps> = ({ showAnswer, questionId, audioBlod }) => {
  const { timePractice } = useSelector((state: RootState) => state.exam);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (showAnswer) {
      fetchPracticeScore();
    }
  }, [showAnswer, audioBlod]);

  const fetchPracticeScore = async () => {
    if (!audioBlod) return;
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('questionId', questionId);
      formData.append('answer', '1');
      formData.append('file', audioBlod);
      formData.append('time', timePractice.toString());
      const res = await practiceScore(formData);
      // console.log(res);
      // const { score } = res;
      // if (typeof score === 'object') {
      //   setScoreInfo((prev) => ({ ...prev, ...score }));
      // }
      if (res.statusCode === 200) {
        notificationController.success({ message: res.message });
      }
    } catch (error) {
      console.error(error);
      notificationController.error({ message: 'Xảy ra lỗi. Vui lòng thử lại sau' });
    } finally {
      setLoading(false);
    }
  };

  if (loading)
    return (
      <div className="flex items-center justify-center">
        <Spin />
      </div>
    );

  return (
    // <S.CardAnswer>
    //   <S.CardAnswerHead>
    //     <S.Title level={5}>Answer</S.Title>
    //   </S.CardAnswerHead>

    //   {loading ? (
    //     <div className="flex items-center justify-center">
    //       <Spin />
    //     </div>
    //   ) : (
    //     <>
    //       {audioQuestion && (
    //         <S.Audio>
    //           <p className="text-sm font-semibold mb-4">System's Answer</p>
    //           <Waveform url={audioQuestion} />
    //           <p className="text-sm font-semibold mt-4">{gradingContent}</p>
    //         </S.Audio>
    //       )}

    //       <S.Audio>
    //         <p className="text-sm font-semibold mb-4">Student's record</p>
    //         {audioURL && <Waveform url={audioURL} />}
    //       </S.Audio>

    //       <S.CardAnswerBody>
    //         {transcript ? (
    //           <>
    //             <S.Grading>Transcript</S.Grading>
    //             <S.Content></S.Content>
    //           </>
    //         ) : (
    //           <>
    //             <S.Grading>Grading</S.Grading>
    //             <S.Content>
    //               {gradingContent}
    //               <S.LevelList>
    //                 <div className="flex items-center gap-2">
    //                   <S.Good></S.Good>
    //                   <span className="text-black">Good</span>
    //                 </div>
    //                 <div className="flex items-center gap-2">
    //                   <S.Average></S.Average>
    //                   <span className="text-black">Average</span>
    //                 </div>
    //                 <div className="flex items-center gap-2">
    //                   <S.Missing></S.Missing>
    //                   <span className="text-black">Missing</span>
    //                 </div>
    //               </S.LevelList>
    //             </S.Content>
    //           </>
    //         )}

    //         <S.Formula>
    //           <S.Recognition>
    //             <S.Block>
    //               <p>Content</p>
    //               <p>{scoreInfo.content}/90</p>
    //             </S.Block>
    //             <S.Plus>+</S.Plus>
    //             <S.Block>
    //               <p>Pronunciation</p>
    //               <p>0/90</p>
    //             </S.Block>
    //             <S.Plus>+</S.Plus>
    //             <S.Block>
    //               <p>Fluency</p>
    //               <p>{scoreInfo.fluency}/90</p>
    //             </S.Block>
    //             <S.Plus>=</S.Plus>

    //             <S.Block>
    //               <p>Total</p>
    //               <p>{scoreInfo.total / 3}/90</p>
    //             </S.Block>
    //           </S.Recognition>
    //         </S.Formula>
    //       </S.CardAnswerBody>
    //       <S.CardAnswerFooter>
    //         {showNote && (
    //           <>
    //             <p className="text-xl font-bold">Notes</p>
    //             <p className="text-base font-normal text-gray-500">
    //               Improve your Read Aloud skills with the PTE Magic - Read Aloud Speaking Advance Feature
    //             </p>
    //           </>
    //         )}

    //         {/* <Button className="mt-4" type="primary">
    //                 Try now
    //             </Button> */}
    //       </S.CardAnswerFooter>
    //     </>
    //   )}
    // </S.CardAnswer>
    <></>
  );
};
